import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import isUndefined from 'lodash/isUndefined';

import { IPolicyInfoRuleResultInfo, getViolationString } from 'obt-common';
import { convertRichTextToPlainText } from 'src/components/RichTextEditor/utils';
import { useSubViolationText } from 'src/app/shared/components/policy/PolicyViolationsModal/PolicyViolationsTable/hooks/useSubViolationText';
import {
  PolicyInfoRow,
  HeaderTitle,
  Divider,
  Predicate,
  ExpectedValue,
  PredicateLabel,
  ActualValue,
  PolicyInfoLabel,
  PolicyInfoValue,
  ActualRating,
  ExpectedRating,
  ContentWrapper,
  SubViolationInfo,
} from './index.styles';

export interface IPolicyViolationsProps {
  ruleInfos: IPolicyInfoRuleResultInfo[];
}

const PolicyViolations = ({ ruleInfos }: IPolicyViolationsProps): JSX.Element => {
  const { t: tCommon } = useTranslation('COMMON');
  const { t: tt } = useTranslation('WEB');

  const { getSubViolationText } = useSubViolationText();

  return (
    <ContentWrapper>
      <PolicyInfoRow my="16px">
        <PolicyInfoLabel>
          <HeaderTitle>{tt('Policy rules')}:</HeaderTitle>
        </PolicyInfoLabel>
        <PolicyInfoValue>
          <HeaderTitle>{tt('This booking')}:</HeaderTitle>
        </PolicyInfoValue>
      </PolicyInfoRow>
      {ruleInfos.map((rule) => {
        const violationInfo = rule.violationInfos[0];
        const subViolationInfo = rule?.subViolationInfos?.[0];

        if (!violationInfo) {
          return null;
        }

        return (
          <Fragment key={violationInfo.predicateString}>
            <Divider />
            <PolicyInfoRow my="12px" data-testid="out-of-policy-violation-row">
              <PolicyInfoLabel>
                <Predicate>
                  <PredicateLabel>{convertRichTextToPlainText(violationInfo.predicateString)}:</PredicateLabel>
                  {isUndefined(violationInfo.expectedValue?.rating) ? (
                    <ExpectedValue>
                      {getViolationString({ value: violationInfo.expectedValue, t: tCommon })}
                    </ExpectedValue>
                  ) : (
                    <ExpectedRating
                      data-testid="out-of-policy-rating-stars"
                      readOnly
                      value={violationInfo.expectedValue?.rating}
                    />
                  )}
                </Predicate>
                {subViolationInfo ? <SubViolationInfo>{getSubViolationText(subViolationInfo)}</SubViolationInfo> : null}
              </PolicyInfoLabel>
              <PolicyInfoValue>
                {isUndefined(violationInfo.actualValue?.rating) ? (
                  <ActualValue>
                    {getViolationString({ value: violationInfo.actualValue, rounding: 'floor', t: tCommon })}
                  </ActualValue>
                ) : (
                  <ActualRating readOnly value={violationInfo.actualValue?.rating} />
                )}
              </PolicyInfoValue>
            </PolicyInfoRow>
          </Fragment>
        );
      })}
    </ContentWrapper>
  );
};

export default PolicyViolations;
